import modalActions from "actions/modal";
import { Transition } from "components/shared/column";
import { Field, Select } from "components/shared/form";
import Loader from "components/shared/loader";
import debounce from "lodash/debounce";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { alert } from "services/alert";
import { list as logistsList } from "sources/books/employees";
import { getItem as getCarItem, apply as saveCarItem, numbersList as trucksList } from "sources/books/trucks";

const logistConfig = {
    label: "Выберите логиста",
    inputProps: { name: "logistId" },
    url: logistsList,
    propName: "fullNameOrEmail",
};

class AddLogist extends Component {
    state = {
        logistId: "",
        searchString: "",
        cars: [],
        isLoading: false,
    };

    constructor(props) {
        super(props);
        this.loadCars = debounce(this.loadCars, 500);
    }

    loadCars = () => {
        this.setState({ isLoading: true }, () => {
            const filter = {
                start: 0,
                length: 99,
                filters: [{ dataIndex: "number", value: this.state.searchString }],
            };
            trucksList(filter).then((cars) => this.setState({ cars, isLoading: false }));
        });
    };

    renderHead = () => {
        const { back } = this.props;
        return (
            <div className="book-show__head">
                <div className="book-show__close close close--sm" onClick={back} />
                <div className="book-show__title">Добавление машин к логисту</div>
            </div>
        );
    };

    renderLogistSelect = (props) => {
        const defProps = {
            fieldWrapper: "col-md-3 col-sm-5",
            labelWrapper: "col-form-label col-form-label-sm col-md-2 col-sm-4",
            onChange: (newValue) => this.setState({ logistId: newValue.value }),
            value: this.state.logistId,
        };
        return <Select {...defProps} {...props} />;
    };

    carSearchInput = () => {
        const props = {
            label: "Поиск по машинам",
            inputProps: { name: "searchString" },
            fieldWrapper: "col-md-3 col-sm-5",
            labelWrapper: "col-form-label col-form-label-sm col-md-2 col-sm-4",
            value: this.state.searchString,
            onChange: (newValue) => {
                this.setState({ searchString: newValue.value });
                this.loadCars();
            },
        };
        return <Field {...props} />;
    };

    saveLogist = (car) => saveCarItem({ ...car, logistId: this.state.logistId });

    addCarToLogist = (car) => {
        getCarItem({ id: car.id }).then((data) => {
            if (data.logistId === this.state.logistId) {
                return alert({ message: "Ваш запрос выполнен успешно", type: "success", title: "Успешно!" });
            }
            if (!data.logistId) {
                this.saveLogist(data);
            } else {
                const filter = {
                    filters: [{ dataIndex: "id", value: data.logistId }],
                };
                logistsList(filter).then(({ 0: logist }) => {
                    const config = {
                        name: "confirm",
                        title: "Смена логиста",
                        text: `Данный автомобиль прикреплен за логистом ${logist.fullNameOrEmail}. Хотите его изменить?`,
                        buttons: {
                            confirm: "Изменить логиста",
                        },
                        action: () => this.saveLogist(data),
                    };
                    this.props.modal(config);
                });
            }
        });
    };

    renderCarItem = (car, index) => {
        return (
            <div className="pb-2" key={index}>
                <div className="mr-2 d-inline-block">
                    {index + 1}. {car.number}
                </div>
                <a className="btn btn-sm btn-brand" onClick={this.addCarToLogist.bind(this, car)}>
                    Добавить
                </a>
            </div>
        );
    };

    renderCarSearchFields = () => {
        const { isLoading } = this.state;
        return (
            <div>
                {this.carSearchInput()}
                <div className="position-relative">
                    {isLoading && (
                        <div className="loader-snippet--disable-loader">
                            <Loader />
                        </div>
                    )}
                    {this.state.cars.map(this.renderCarItem)}
                </div>
            </div>
        );
    };

    renderBodyWrap = () => {
        return (
            <Fragment>
                {this.renderLogistSelect(logistConfig)}
                {this.state.logistId && this.renderCarSearchFields()}
            </Fragment>
        );
    };

    render() {
        return (
            <Transition dir="full">
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className="book-show__body">
                        <div className="h-100 overflow-auto">{this.renderBodyWrap()}</div>
                    </div>
                </div>
            </Transition>
        );
    }
}

export default connect(
    (_state) => ({}),
    (dispatch) => ({
        modal: (params) => dispatch(modalActions.open(params)),
    }),
)(AddLogist);
